import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorsComponent } from './errors/errors.component';

import { HaloUnsubscribeComponent } from './halo-unsubscribe/halo-unsubscribe.component';
import { SoftwareDownloadComponent } from './software-download/software-download.component';
import { TncComponent } from './tnc/tnc.component';

const routes: Routes = [
  { path: '', redirectTo: '/unsubscribe', pathMatch: 'full' },
  { path: 'unsubscribe', component: HaloUnsubscribeComponent },
  { path: 'softwareDownload', component: SoftwareDownloadComponent },
  { path: 'errors', component: ErrorsComponent },
  { path: 'termsOfUse', component: TncComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BasicLayoutRoutingModule {}
